import { appConfig } from "../config/config";
import { Job } from "../dtos/job";
import api from "./api/api";

export const getJob = async (jobId?: string): Promise<Job> => {
  return api.get<Job>(`common/${appConfig.tenant}/jobs/${jobId}`);
};
